import React, { useEffect, useState } from 'react'
import { complianceApi } from '@/shared/api/complianceApi'
import { MarkdownRenderer } from '@/shared/components/MarkdownRenderer'
import { FileText, Loader } from 'lucide-react'

export const TermsPage: React.FC = () => {
  const [markdown, setMarkdown] = useState<string>('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    // Dynamic SEO title
    document.title = 'Terms of Service | NoTimeToDelay – Link2Earn'

    // Fetch terms text
    complianceApi.getTermsOfService()
      .then((data) => {
        setMarkdown(data)
        setLoading(false)
      })
      .catch((err) => {
        console.error('Failed to load Terms of Service:', err)
        setError('Unable to load Terms of Service. Please try again later.')
        setLoading(false)
      })
  }, [])

  return (
    <div 
      style={{
        width: '100%',
        maxWidth: '800px',
        margin: 'var(--space-12) auto',
        padding: '0 var(--space-6)',
      }}
    >
      <div 
        style={{
          backgroundColor: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-xl)',
          padding: 'var(--space-8)',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '300px', gap: 'var(--space-4)' }}>
            <Loader size={32} className="animate-spin" style={{ color: 'var(--color-accent)' }} />
            <span style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>Loading Terms of Service...</span>
          </div>
        ) : error ? (
          <div style={{ padding: 'var(--space-6)', backgroundColor: 'var(--color-error-subtle)', border: '1px solid var(--color-error)', borderRadius: 'var(--radius-md)', color: 'var(--color-error)', fontSize: 'var(--text-sm)' }}>
            {error}
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', marginBottom: 'var(--space-6)', borderBottom: '1px solid var(--color-border)', paddingBottom: 'var(--space-4)' }}>
              <FileText size={28} style={{ color: 'var(--color-accent)' }} />
              <h1 style={{ margin: 0, fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-text-primary)' }}>Terms of Service</h1>
            </div>
            <MarkdownRenderer content={markdown} />
          </div>
        )}
      </div>
    </div>
  )
}
export default TermsPage
